import { useNavigation } from "@react-navigation/core";
import { Box, Button, FlatList, HStack, Text, VStack } from "native-base";

type Props = {};

export default function BeforeTreatment({}: Props) {
  const navigation = useNavigation();

  const data = [
    {
      id: "1",
      title: "Rastreio e diagnóstico precoce",
      description: "Realização de mamografia",
      infoId: 1,
    },
    {
      id: "2",
      title: "Primeiro Tratamento",
      description:
        "Acesso ao primeiro tratamento em até 60 dias após o diagnóstico",
      infoId: 2,
    },
    {
      id: "3",
      title: "3 dias de ausência ao trabalho",
      description:
        "Trabalhadoras CLT podem faltar até 3 dias do emprego para realização de exames preventivos.",
      infoId: 3,
    },
  ];

  const handleClickMoreInfo = (infoId: number) => {
    navigation.navigate("InfoPage", { infoId });
  };

  return (
    <Box flex={1} bgColor="white" p="8">
      <VStack space={8} w="100%">
        <Text
          fontSize="2xl"
          fontWeight="bold"
          textAlign="center"
          color="#f4545c"
        >
          Antes do Tratamento você tem acesso aos seguintes direitos
        </Text>
        <FlatList
          w="100%"
          h="80%"
          data={data}
          renderItem={({ item }) => (
            <Box pl={["0", "4"]} pr={["0", "5"]} pb="8">
              <HStack
                space={[2, 3]}
                justifyContent="space-between"
                alignItems="center"
              >
                <VStack space={2}>
                  <Text color="#e8af9d" bold fontSize="md">
                    {item.title}
                  </Text>
                  <Text
                    color="coolGray.600"
                    _dark={{
                      color: "warmGray.200",
                    }}
                    fontSize="sm"
                    maxW="80%"
                  >
                    {item.description}
                  </Text>
                </VStack>
                <Button
                  bg="#f4545c"
                  h="16"
                  onPress={() => handleClickMoreInfo(item.infoId)}
                >
                  + Info
                </Button>
              </HStack>
            </Box>
          )}
          keyExtractor={(item) => item.id}
        />
      </VStack>
    </Box>
  );
}
